import { isEmailStyleUserName } from "./publicProfile";
import { ellipsizeProfileText } from "./profileText";

const GENERATED_PROFILE_NAMES = new Set(["new user", "new-user"]);
const GENERATED_PROFILE_BIOS = new Set(["this is my bio"]);

function normalizeDisplayName(value) {
  return String(value || "").replace(/\s+/g, " ").trim();
}

function getDisplayText(value) {
  const text = normalizeDisplayName(value);
  if (!text) return "";

  const displayText = isEmailStyleUserName(text) ? text.split("@")[0] : text;
  return ellipsizeProfileText(displayText);
}

export function isProfileNameSetupNeeded(profile = {}, isOwnProfile = false) {
  if (!isOwnProfile) return false;

  const displayName = normalizeDisplayName(profile?.displayName).toLowerCase();
  return !displayName || GENERATED_PROFILE_NAMES.has(displayName);
}

export function getProfileHeroDisplayName(profile = {}, isOwnProfile = false, visibleHandle = "") {
  if (isProfileNameSetupNeeded(profile, isOwnProfile)) {
    return "Complete your profile";
  }

  const displayName = getDisplayText(profile?.displayName);
  if (displayName && !GENERATED_PROFILE_NAMES.has(displayName.toLowerCase())) {
    return displayName;
  }

  return visibleHandle ? `@${visibleHandle}` : getDisplayText(profile?.userName) || "Profile";
}

export function getProfileHeroBioText(profile = {}, isOwnProfile = false) {
  const bio = String(profile?.bio || "").trim();
  if (bio && !GENERATED_PROFILE_BIOS.has(bio.toLowerCase())) return bio;

  return isProfileNameSetupNeeded(profile, isOwnProfile)
    ? "Add your name so friends know who they are connecting with."
    : "";
}

export function getProfileHeroActionLabel(profile = {}, isOwnProfile = false) {
  return isProfileNameSetupNeeded(profile, isOwnProfile) ? "Add your name" : "Edit Profile";
}
